import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import FieldSet from 'flarum/common/components/FieldSet';
import Button from 'flarum/common/components/Button';
import PwaInstallPrompt from './components/PwaInstallPrompt';
import AbsoluteDateBadge from './components/AbsoluteDateBadge';
import addRichToolbarButtons from './components/RichToolbarButtons';
import addImageLightbox from './addImageLightbox';
import addReplyAffordances from './addReplyAffordances';
import addMessagePolish from './addMessagePolish';
import addModalLabels from './addModalLabels';
import syncThemeColor from './syncThemeColor';
import alignCountLabels from './alignCountLabels';
import { applyArabicCountOverrides } from './utils/arabicCounts';
export { default as PwaInstallPrompt } from './components/PwaInstallPrompt';
export { default as ImageLightbox } from './components/ImageLightbox';
export { default as addImageLightbox } from './addImageLightbox';
export { default as AbsoluteDateBadge } from './components/AbsoluteDateBadge';
export { default as addRichToolbarButtons } from './components/RichToolbarButtons';
app.initializers.add('itqan-theme', () => {
  applyArabicCountOverrides(app);
  addImageLightbox();
  addReplyAffordances();
  addMessagePolish();
  addModalLabels();
  syncThemeColor();
  alignCountLabels();

  // Colour scheme switching is Flarum 2.0's own (header + settings), driven by
  // `data-theme`. The theme styles that attribute; it does not manage it.

  extend('flarum/forum/components/SessionDropdown', 'items', function (items) {
    items.add('pwaInstall', m(Button, {
      icon: "fas fa-mobile-alt",
      onclick: () => PwaInstallPrompt.openModal()
    }, app.translator.trans('itqan-theme.forum.pwa.menu')), -10);
  });
  extend('flarum/forum/components/SettingsPage', 'settingsItems', function (items) {
    items.add('itqanPwa', m(FieldSet, {
      className: "Settings-pwa",
      label: app.translator.trans('itqan-theme.forum.pwa.settings_heading')
    }, m(Button, {
      className: "Button Button--primary",
      icon: "fas fa-download",
      onclick: () => PwaInstallPrompt.openModal()
    }, app.translator.trans('itqan-theme.forum.pwa.settings_description'))), 4);
  });

  // ==========================================
  // Archival post absolute timestamps (moved from itqan-discussions, PR #20)
  // ==========================================
  extend('flarum/forum/components/PostMeta', 'viewItems', function (items) {
    const post = this.attrs.post;
    if (!post || !post.createdAt()) return;
    const time = post.createdAt();

    // Flarum 2.0 removed ItemList::replace(); remove + add is the equivalent.
    items.remove('time');
    items.add('time',
    // A button, not an anchor: this toggle has no href, and an anchor
    // without one is not crawlable (Lighthouse: crawlable-anchors). It needs
    // the same text-button classes core's PostMeta time uses — a bare
    // <button> renders with the browser's grey native chrome.
    m("button", {
      type: "button",
      className: "Button Button--text Dropdown-toggle Button--link",
      onclick: e => this.selectPermalink(e),
      "data-toggle": "dropdown"
    }, m(AbsoluteDateBadge, {
      time: time
    })), 100);
  });

  // ==========================================
  // Rich composer toolbar: table / quote / code buttons (moved from itqan-composer-tools, PR #12)
  // ==========================================
  addRichToolbarButtons();
});